
export class DateRange {
    
    constructor(public beginDate:Date,
                public endDate:Date) {
    }

}